var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoleAdmin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7546 19H10.6666C8.98688 19 7.37597 19.6673 6.18824 20.855C5.00051 22.0427 4.33325 23.6536 4.33325 25.3333V28C4.33325 28.5523 4.78097 29 5.33325 29C5.88554 29 6.33325 28.5523 6.33325 28V25.3333C6.33325 24.1841 6.7898 23.0819 7.60246 22.2692C8.41511 21.4565 9.51731 21 10.6666 21H16.5815C16.8753 20.2743 17.2724 19.6016 17.7546 19Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9998 5C13.6066 5 11.6665 6.9401 11.6665 9.33333C11.6665 11.7266 13.6066 13.6667 15.9998 13.6667C18.3931 13.6667 20.3332 11.7266 20.3332 9.33333C20.3332 6.9401 18.3931 5 15.9998 5ZM9.6665 9.33333C9.6665 5.83553 12.502 3 15.9998 3C19.4976 3 22.3332 5.83553 22.3332 9.33333C22.3332 12.8311 19.4976 15.6667 15.9998 15.6667C12.502 15.6667 9.6665 12.8311 9.6665 9.33333Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 31C27.866 31 31 27.866 31 24C31 20.134 27.866 17 24 17C20.134 17 17 20.134 17 24C17 27.866 20.134 31 24 31ZM25.0854 22.6414H28.5L25.5882 24.7586L26.9118 28.2L24 26.0823L21.0882 28.2L22.4118 24.7586L19.5 22.6414H22.9146L24 19.2L25.0854 22.6414Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoleAdmin);
export default __webpack_public_path__ + "static/media/role-admin.fe892930f785fc9bb5694c214e900a77.svg";
export { ForwardRef as ReactComponent };